import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import {
  IAdditionalService,
  IAdditionalServiceState,
} from "./additionalserviceModel";
import {
  additionalServiceActiveInactive,
  createAdditionalService,
  deleteAdditionalService,
  getAdditionalServiceByID,
  getAllActiveAdditionalServices,
  getAllAdditionalServices,
  updateAdditionalService,
} from "./services/additionalservice.services";

const initialState: IAdditionalServiceState = {
  loading: false,
  formLoading: false,
  error: "",
  AdditionalServiceList: [],
  AdditionalServiceID: null,
  AdditionalServiceDetail: {
    VisaCountryID: null,
    ServiceDescription: "",
    ServiceName: "",
    Price: null,
    IsActive: 1,
  },
};

const additionalServiceSlice = createSlice({
  name: "additionalservice",
  initialState,
  reducers: {
    clearAdditionalServiceDetails: (state) => {
      state.AdditionalServiceDetail = initialState.AdditionalServiceDetail;
    },
    setAdditionalServiceID: (state, action) => {
      state.AdditionalServiceID = action.payload;
    },
    clearAdditionalServiceID: (state) => {
      state.AdditionalServiceID = initialState.AdditionalServiceID;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getAllAdditionalServices.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(
      getAllAdditionalServices.fulfilled,
      (state, action: PayloadAction<IAdditionalService[]>) => {
        state.loading = false;
        state.AdditionalServiceList = action.payload || [];
      }
    );
    builder.addCase(getAllAdditionalServices.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
      state.AdditionalServiceList = [];
    });
    builder.addCase(getAllActiveAdditionalServices.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(
      getAllActiveAdditionalServices.fulfilled,
      (state, action: PayloadAction<IAdditionalService[]>) => {
        state.loading = false;
        state.AdditionalServiceList = action.payload || [];
      }
    );
    builder.addCase(
      getAllActiveAdditionalServices.rejected,
      (state, action) => {
        state.loading = false;
        state.error = action.error.message || "Something went wrong";
        state.AdditionalServiceList = [];
      }
    );
    builder.addCase(createAdditionalService.pending, (state) => {
      state.formLoading = true;
      state.error = "";
    });
    builder.addCase(createAdditionalService.fulfilled, (state) => {
      state.formLoading = false;
    });
    builder.addCase(createAdditionalService.rejected, (state, action) => {
      state.formLoading = false;
      state.error = action.error.message || "Something went wrong";
    });
    builder.addCase(updateAdditionalService.pending, (state) => {
      state.formLoading = true;
      state.error = "";
    });
    builder.addCase(updateAdditionalService.fulfilled, (state) => {
      state.formLoading = false;
    });
    builder.addCase(updateAdditionalService.rejected, (state, action) => {
      state.formLoading = false;
      state.error = action.error.message || "Something went wrong";
    });
    builder.addCase(deleteAdditionalService.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(deleteAdditionalService.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(deleteAdditionalService.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });
    builder.addCase(additionalServiceActiveInactive.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(additionalServiceActiveInactive.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(
      additionalServiceActiveInactive.rejected,
      (state, action) => {
        state.loading = false;
        state.error = action.error.message || "Something went wrong";
      }
    );
    builder.addCase(getAdditionalServiceByID.pending, (state) => {
      state.formLoading = true;
      state.error = "";
    });
    builder.addCase(
      getAdditionalServiceByID.fulfilled,
      (state, action: any) => {
        state.formLoading = false;
        state.AdditionalServiceDetail = action.payload;
      }
    );
    builder.addCase(getAdditionalServiceByID.rejected, (state, action) => {
      state.formLoading = false;
      state.AdditionalServiceDetail = initialState.AdditionalServiceDetail;
      state.error = action.error.message || "Something went wrong";
    });
  },
});

export const {
  clearAdditionalServiceDetails,
  setAdditionalServiceID,
  clearAdditionalServiceID,
} = additionalServiceSlice.actions;
export default additionalServiceSlice.reducer;
